module.exports = __webpack_public_path__ + "img/Fileformats.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Fileformats.svg
// module id = 251
// module chunks = 0